<div class="align-items-center d-flex has-border mt-3 ordersummary-header pb-2">
  <div class="col align-items-center d-flex">
    <h2 class="m-0 wordwrap sec-title">Samples</h2>
  </div>
  <div class="col-auto d-flex align-items-center gap-3">
    <a class="link" (click)="onAddLine()">
      <i class="pi pi-plus-circle"></i> Add Line
    </a>
    <a class="link" (click)="onAddTracking()">
      <i class="pi pi-plus-circle"></i> Add Tracking
    </a>
    <a class="link link-danger" (click)="onDelete()">
      <i class="pi pi-trash"></i> Delete
    </a>
  </div>
</div>

<div class="cstm-collaspse mb-2 mt-2">
  <div [hidden]="isCollapsed">
    <div class="orders-list">
      <p-table
        [value]="samples()"
        [rowHover]="true"
        [scrollable]="true"
        [size]="'small'"
        [resizableColumns]="true"
        [loading]="loading()"
        editMode="cell"
        responsiveLayout="scroll"
        dataKey="id"
        [(selection)]="selectedSamples"
        styleClass="p-datatable-customers no-overfollow ordersLineItems no-wrap table-hover-bg scroll-tble table-listing">
        <ng-template pTemplate="header">
          <tr class="table-head">
            <th style="width: 4rem"></th>
            <th style="width: 3rem">
              <p-tableHeaderCheckbox />
            </th>
            <th>Sample PO #</th>
            <th>Supplier</th>
            <th>NickName</th>
            <th>Vendor SKU</th>
            <th>ESD</th>
            <th>Method</th>
            <th>Tracking</th>
            <th>Shipping Status</th>
            <th>Created Date</th>
            <th>IHD</th>
            <th>Status</th>
            <th>Quantity</th>
            <th>Net Total</th>
            <th>Note</th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-sample>
          <tr>
            <td>
              @if (editingRowId() !== sample.id) {
                <button
                  pButton
                  pRipple
                  type="button"
                  icon="pi pi-pencil"
                  class="p-button-rounded p-button-text"
                  pTooltip="Edit Nickname"
                  tooltipPosition="top"
                  (click)="startEditNickname(sample)"></button>
              } @else {
                <button
                  pButton
                  pRipple
                  type="button"
                  icon="pi pi-check"
                  [loading]="nicknameSaving()"
                  [disabled]="nicknameSaving()"
                  class="p-button-rounded p-button-text p-button-success selectable-color"
                  (click)="saveNickname(sample)"></button>
                <button
                  pButton
                  pRipple
                  type="button"
                  icon="pi pi-times"
                  [disabled]="nicknameSaving()"
                  class="p-button-rounded p-button-text p-button-danger"
                  (click)="cancelEditNickname()"></button>
              }
            </td>
            <td>
              <p-tableCheckbox [value]="sample" />
            </td>
            <td>
              <a class="link">{{ sample.samplePONumber }}</a>
            </td>
            <td>{{ sample.supplier }}</td>
            <td
              class="text-truncate max-width-10"
              [pTooltip]="sample.nickName"
              tooltipPosition="top">
              @if (editingRowId() === sample.id) {
                <input
                  pInputText
                  type="text"
                  class="form-control"
                  style="width: 8rem"
                  [ngModel]="editingNickname()"
                  (ngModelChange)="editingNickname.set($event)"
                  (keydown.enter)="saveNickname(sample)"
                  (keydown.escape)="cancelEditNickname()"
                  [disabled]="nicknameSaving()"
                  maxlength="200" />
              } @else {
                {{ sample.nickName }}
              }
            </td>
            <td>{{ sample.vendorSku }}</td>
            <td pEditableColumn>
              <p-cellEditor>
                <ng-template pTemplate="input">
                  <p-datePicker
                    [(ngModel)]="sample.shipDate"
                    [showButtonBar]="false"
                    [inputStyle]="{ height: '30px' }"
                    [style]="{ width: '100%' }"
                    [appendTo]="'body'"
                    dateFormat="mm-dd-yy"
                    (onSelect)="onSampleShipDateSelection($event, sample)">
                  </p-datePicker>
                </ng-template>
                <ng-template pTemplate="output">
                  <span>{{ sample.shipDate | date: "MMM d, y" }}</span>
                </ng-template>
              </p-cellEditor>
            </td>
            <td>{{ sample.shippingMethodName || sample.method }}</td>
            <td>
              <a class="link" (click)="showTrackingDetailList(sample)">{{
                sample.trackingCount
              }}</a>
            </td>
            <td>
              <p-popover
                #trackingTooltip
                [style]="{ width: '30px', height: '60px' }"
                styleClass="tracking-popup">
                <ng-template pTemplate>
                  <div class="row">
                    <p>
                      <strong>Status</strong><br />
                      <span *ngIf="sample.deliveredCount !== 0"
                        >Delivered: {{ sample.deliveredCount }}/{{
                          sample.trackingCount
                        }}</span
                      >
                      <span *ngIf="sample.inTransitCount !== 0"
                        >In-Transit: {{ sample.inTransitCount }}/{{
                          sample.trackingCount
                        }}</span
                      >
                      <span *ngIf="sample.shippedCount !== 0"
                        >Shipped: {{ sample.shippedCount }}/{{
                          sample.trackingCount
                        }}</span
                      >
                      <span *ngIf="sample.exceptionCount !== 0"
                        >Exception: {{ sample.exceptionCount }}/{{
                          sample.trackingCount
                        }}</span
                      >
                    </p>
                  </div>
                </ng-template>
              </p-popover>
              <div
                class="clickable"
                *ngIf="sample"
                (click)="trackingTooltip.toggle($event)">
                <p-chart
                  type="bar"
                  width="125px"
                  height="50px"
                  [data]="sample.stackedDataOptions"
                  [options]="sample.chartOptions"></p-chart>
              </div>
            </td>
            <td>{{ sample.createdDate | date: "MMM d, y" }}</td>
            <td>{{ sample.ihd | date: "MMM d, y" }}</td>
            <td>{{ sample.status }}</td>
            <td>{{ sample.quantity }}</td>
            <td>{{ sample.lineAmount | currency }}</td>
            <td class="text-center">
              <a
                class="link no-decoration"
                (click)="showInputFieldForLineNote(sample)">
                <i *ngIf="!sample.notes" class="pi pi-plus"></i>
                <i *ngIf="sample.notes" class="pi pi-pen-to-square"></i>
              </a>
            </td>
          </tr>
        </ng-template>

        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="16" class="text-center py-3 text-muted">
              No Samples Found
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>

<!-- Add Sample PO Lines Modal -->
<jni-add-sample-po-modal
  [visible]="showAddSamplePoModal"
  [clientName]="clientName()"
  (visibleChange)="showAddSamplePoModal = $event"
  (loadingChange)="addLineLoaderEvent.emit($event)"
  (linesSelected)="onLinesSelected($event)">
</jni-add-sample-po-modal>

<!-- Add Tracking Information Modal -->
<p-dialog
  header="Add Tracking Information"
  [modal]="true"
  [resizable]="false"
  [draggable]="false"
  [visible]="addTrackingModal()"
  (visibleChange)="addTrackingModal.set($event)"
  appendTo="body"
  [style]="{ width: '60vw', 'border-radius': '10px' }"
  styleClass="order-dialog">
  <jni-add-tracking
    (saveTrackingListEvent)="
      addTrackingData($event.trackingList, $event.isManualTracking)
    "
    [workflowTrackingList]="workflowTrackingList"
    [totalLineQuantity]="trackingLineQuantity"
    [vendorSKU]="trackingLineVendorSKU"
    [shippingMethod]="trackingLineShippingMethod"
    [lineRecIdD365]="trackingLineRecIdD365"
    (closeModalDialogEvent)="closeModalDialog()"
    (deleteTrackingRecordEvent)="deleteTrackingRecord($event)"
    [addTrackingLineNumber]="addTrackingLineNumber"
    [addTrackingPurchaseOrder]="addTrackingPurchaseOrder"
    [shippingMethodName]="trackingLineShippingMethodName">
  </jni-add-tracking>
</p-dialog>

<!-- Tracking Information (list) Modal -->
<p-dialog
  [modal]="true"
  [resizable]="false"
  [draggable]="false"
  [visible]="trackingListModal()"
  (visibleChange)="trackingListModal.set($event)"
  [style]="{ width: '50vw', margin: '20px' }"
  styleClass="order-dialog"
  [closable]="true"
  appendTo="body">
  <ng-template pTemplate="header">
    <div class="tracking-header d-flex justify-content-between">
      <div class="d-flex gap-2">
        <h2 class="mb-0">Tracking Information</h2>
        <jni-spinner *ngIf="smallTrackingListLoader()"></jni-spinner>
      </div>
    </div>
  </ng-template>
  <jni-tracking-list
    [workflowTrackingList]="trackingDetailsList"
    [showDetailLinks]="true"
    (showTrackingDetailEvent)="showTrackingDetails($event)"
    (showTrackingHistoryEvent)="showTrackingHistory($event)"
    [showEdit]="true"
    (deleteTrackingRecordEvent)="deleteTrackingRecord($event)"
    (rowEditSaveEvent)="updateManualTrackingStatus($event)"
    (refreshGrid)="refreshTrackingList()">
  </jni-tracking-list>

  <div class="d-flex pt-2 justify-content-end gap-2">
    <p-button
      label="Add Tracking"
      [disabled]="disableAddTracking()"
      (click)="openAddManualTrackingModal()" />
    <p-button
      label="Close"
      (click)="closeModal()"
      variant="outlined"
      severity="secondary" />
  </div>
</p-dialog>

<!-- Tracking History Modal -->
<p-dialog
  [visible]="trackingHistoryModalOpen()"
  (visibleChange)="trackingHistoryModalOpen.set($event)"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: '35%' }"
  header="Tracking"
  appendTo="body">
  <jni-tracking-list-popup
    [trackingHistoryList]="trackingHistoryList"
    (displayChange)="closeTrackingModals()"
    [trackingNumber]="historyTrackingNumber">
  </jni-tracking-list-popup>
</p-dialog>

<!-- Tracking Details Modal -->
<p-dialog
  header="Tracking Details"
  [visible]="trackingDetailsModalOpen()"
  (visibleChange)="trackingDetailsModalOpen.set($event)"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: '800px', margin: '20px 80px' }"
  appendTo="body">
  <jni-tracking-detail-popup
    (displayChange)="closeTrackingModals()"
    [trackingNumberDetail]="trackingDetailsBindingObj"
    [trackingDimension]="trackingDimension"
    [trackingWeight]="trackingWeight"
    [isUPS]="isUPS">
  </jni-tracking-detail-popup>
</p-dialog>

<!-- Add Manual Tracking Modal -->
<p-dialog
  [visible]="displayAddManualTrackingModal()"
  (visibleChange)="displayAddManualTrackingModal.set($event)"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: '35%' }"
  header="Add Tracking"
  [closable]="true"
  appendTo="body">
  <div class="col">
    <div class="row">
      <div class="form-group has-float-label mb-2">
        <label class="form-label">Shipping Method</label>
        <p-select
          id="sampleShippingMethod"
          [(ngModel)]="manualMethod"
          [options]="manualShippingMethods"
          optionLabel="shippingMethod"
          optionValue="code"
          appendTo="body"
          [filter]="true"
          [showClear]="true">
        </p-select>
      </div>
    </div>
    <div>
      <div class="form-group has-float-label mb-2">
        <label class="form-label">Tracking</label>
        <textarea
          pInputText
          class="form-control"
          type="text"
          [(ngModel)]="trackings"></textarea>
      </div>
    </div>
  </div>
  <div class="d-flex pt-2 justify-content-end">
    <p-button label="Add Tracking" (click)="addManualTrackingNumbers()" />
  </div>
</p-dialog>

<!-- Sample Line Notes Sidebar -->
<jni-workflow-line-notes
  *ngIf="displaySidebarForNotes"
  [(display)]="displaySidebarForNotes"
  [projectWorkflowId]="workflowId()"
  [lineRecId]="noteLineRecId"
  [notes]="notes"
  (closeSidebar)="closeSideBarForNotes()"
  (saveNotesEvent)="saveNotes($event)">
</jni-workflow-line-notes>
